/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object";

export default ($axios: any) => ({
  // 가이드 조회
  async index(data?: any) {
    return camelize(
      await $axios.get(`/guidelines`, snakelize({ params: data }))
    );
  },
});
